module.exports = __webpack_public_path__ + "media/images/icons/outlined/download-32d414575064a656a03fd8e04c24eacd.svg";